export default function LoadCustomFonts() {
  const fontUrl = process.env.REACT_APP_CUSTOM_FONT_URL;

  const style = document.createElement("style");
  style.innerHTML = `
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-Thin.ttf") format("truetype");
        font-weight: 100;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-ExtraLight.ttf") format("truetype");
        font-weight: 200;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-Light.ttf") format("truetype");
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-Regular.ttf") format("truetype");
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-Medium.ttf") format("truetype");
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-SemiBold.ttf") format("truetype");
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-Bold.ttf") format("truetype");
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Sora";
        src: url("${fontUrl}/Sora/Sora-ExtraBold.ttf") format("truetype");
        font-weight: 800;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "DM Sans";
        src: url("${fontUrl}/DMSans/DMSans-Regular.ttf") format("truetype");
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "DM Sans";
        src: url("${fontUrl}/DMSans/DMSans-Italic.ttf") format("truetype");
        font-weight: 400;
        font-style: italic;
        font-display: swap;
      }
      @font-face {
        font-family: "DM Sans";
        src: url("${fontUrl}/DMSans/DMSans-Bold.ttf") format("truetype");
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "DM Sans";
        src: url("${fontUrl}/DMSans/DMSans-BoldItalic.ttf") format("truetype");
        font-weight: 700;
        font-style: italic;
        font-display: swap;
      }
    `;
  document.head.appendChild(style);
}
